import { makeObservable, observable, computed, action } from 'mobx';
import { persist } from 'mobx-persist';
import AlertModel from 'store/model/AlertModel';

class UiState {
  language = 'en';

  pendingRequestCount = 0;

  groupId = null;

  sessionId = null;

  organisationName = '';

  isMenuOpen = false;

  alertModel = null;

  constructor() {
    persist('language')(this, 'language');
    persist('groupId')(this, 'groupId');
    persist('sessionId')(this, 'sessionId');
    persist('organisationName')(this, 'organisationName');

    makeObservable(this, {
      language: observable,
      groupId: observable,
      sessionId: observable,
      organisationName: observable,
      pendingRequestCount: observable,
      isMenuOpen: observable,
      alertModel: observable,
      appIsInSync: computed,
      increasePendingRequest: action,
      decreasePendingRequest: action,
      setAlertModel: action,
      removeAlertModel: action,
      setOrganisationName: action,
      toggleMenu: action,
      hideMenu: action
    });
  }

  get appIsInSync() {
    return this.pendingRequestCount === 0;
  }

  increasePendingRequest() {
    this.pendingRequestCount += 1;
  }

  decreasePendingRequest() {
    if (this.pendingRequestCount > 0) {
      this.pendingRequestCount -= 1;
    }
  }

  setAlertModel(alertModel) {
    this.alertModel = alertModel;
  }

  removeAlertModel() {
    this.alertModel = null;
  }

  showError(error) {
    this.createAlert({ title: 'Error', ok: 'OK', message: error.toString() });
  }

  createAlert({ title, message, ok, okHandler, cancel }) {
    const alertModel = new AlertModel(
      title,
      message,
      ok,
      () => {
        try {
          okHandler();
        } catch (error) {}
        this.removeAlertModel();
      },
      cancel,
      () => {
        this.removeAlertModel();
      }
    );
    this.setAlertModel(alertModel);
  }

  setOrganisationName(value) {
    this.organisationName = value;
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  hideMenu() {
    this.isMenuOpen = false;
  }
}

export default UiState;
